import { useQuery } from 'react-query';
import { commerciauxDIRQuery } from './useDIRCommerciaux.query';
import { Commercial } from '../../../types/api/endpoints/commercial/commercial.types';

export const ALL_DIR_COMMERCIAUX_QUERY_KEY = 'ALL_DIR_COMMERCIAUX';

export const useDIRCommerciaux = () => {
  return useQuery<Commercial[], Error>(ALL_DIR_COMMERCIAUX_QUERY_KEY, () => commerciauxDIRQuery(), {
    retry: false,
    cacheTime: 0,
  });
};
